import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Directive()
@Injectable()
export class MessagingService {

  currentMessage = new BehaviorSubject(null);
  isChange = false;

  // tslint:disable-next-line: no-output-native
  @Output() change: EventEmitter<boolean> = new EventEmitter();
  constructor(
    private angularFireDB: AngularFireDatabase,
    private angularFireAuth: AngularFireAuth,
    private angularFireMessaging: AngularFireMessaging) {
    this.angularFireMessaging.messages.subscribe(
      (_messaging: AngularFireMessaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      }
    );
    
  }
  SignIn(email: string, password: string) {
    return this.angularFireAuth
      // .auth
      .signInWithEmailAndPassword(email, password)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err;
      });
  }
  SignUp(email: string, password: string) {
    return this.angularFireAuth
      // .auth
      .createUserWithEmailAndPassword(email, password)
      .then(res => {
        return res;
      })
      .catch(error => {
        return error;
      });
  }
  changeVerificationStatus() {
    this.isChange = !this.isChange;
    this.change.emit(this.isChange);
  }
  /* Sign out */
  SignOut() {
    this.angularFireAuth
      // .auth
      .signOut();
  }
  /**
   * update token in firebase database
   * 
   * @param userId userId as a key 
   * @param token token as a value
   */
  updateToken(userId, token) {
    // we can change this function to request our backend service
    this.angularFireAuth.authState.pipe(take(1)).subscribe(
      () => {
        const data = {};
        data[userId] = token;
        this.angularFireDB.object('fcmTokens/').update(data);
      });
  }

  /**
   * request permission for notification from firebase cloud messaging
   * 
   * @param userId userId
   */
  requestPermission() {
    return this.angularFireMessaging.requestToken;
  }

  /**
   * hook method when new notification received in foreground
   */
  receiveMessage() {
    return this.angularFireMessaging.messages;
  }
}